// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.find-job-container {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  gap: 2rem;
}

.find-job-sidebar {
  width: 250px;
  flex-shrink: 0;
}

.find-job-sidebar h3 {
  color: #1e3a5f;
  margin-bottom: 1rem;
}

.find-job-sidebar label {
  display: block;
  font-weight: 600;
  margin-top: 1rem;
  margin-bottom: 0.3rem;
  color: #374151;
  font-size: 0.9rem;
}

.find-job-sidebar select,
.find-job-sidebar input {
  width: 100%;
  padding: 0.6rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.9rem;
  box-sizing: border-box;
}

.filter-btn {
  margin-top: 1.5rem;
  width: 100%;
  padding: 0.7rem;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.filter-btn:hover {
  background: #1e40af;
}

.find-job-main {
  flex: 1 1;
}

.search-bar {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.search-bar input {
  flex: 1 1;
  padding: 0.7rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1rem;
}

.search-bar input:focus {
  outline: none;
  border-color: #2563eb;
}

.search-bar button {
  padding: 0.7rem 1.5rem;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.search-bar button:hover {
  background: #1e40af;
}

.no-results {
  text-align: center;
  color: #9ca3af;
  margin-top: 3rem;
  font-size: 1.1rem;
}

.job-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
}

.view-toggle {
  display: flex;
  gap: 0;
  margin-bottom: 1.5rem;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #d1d5db;
  width: fit-content;
}

.view-toggle button {
  padding: 0.5rem 1.2rem;
  border: none;
  background: white;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  color: #374151;
  transition: background 0.2s;
}

.view-toggle button.active {
  background: #2563eb;
  color: white;
}

.map-wrapper {
  height: 500px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #d1d5db;
  position: relative;
}

.map-no-results {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.9);
  padding: 1rem 1.5rem;
  border-radius: 6px;
  z-index: 1000;
}

@media (max-width: 768px) {
  .find-job-container {
    flex-direction: column;
  }

  .find-job-sidebar {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/FindJob.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,MAAM;EACN,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".find-job-container {\n  display: flex;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  gap: 2rem;\n}\n\n.find-job-sidebar {\n  width: 250px;\n  flex-shrink: 0;\n}\n\n.find-job-sidebar h3 {\n  color: #1e3a5f;\n  margin-bottom: 1rem;\n}\n\n.find-job-sidebar label {\n  display: block;\n  font-weight: 600;\n  margin-top: 1rem;\n  margin-bottom: 0.3rem;\n  color: #374151;\n  font-size: 0.9rem;\n}\n\n.find-job-sidebar select,\n.find-job-sidebar input {\n  width: 100%;\n  padding: 0.6rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  box-sizing: border-box;\n}\n\n.filter-btn {\n  margin-top: 1.5rem;\n  width: 100%;\n  padding: 0.7rem;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.filter-btn:hover {\n  background: #1e40af;\n}\n\n.find-job-main {\n  flex: 1;\n}\n\n.search-bar {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.search-bar input {\n  flex: 1;\n  padding: 0.7rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 1rem;\n}\n\n.search-bar input:focus {\n  outline: none;\n  border-color: #2563eb;\n}\n\n.search-bar button {\n  padding: 0.7rem 1.5rem;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.search-bar button:hover {\n  background: #1e40af;\n}\n\n.no-results {\n  text-align: center;\n  color: #9ca3af;\n  margin-top: 3rem;\n  font-size: 1.1rem;\n}\n\n.job-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1.5rem;\n}\n\n.view-toggle {\n  display: flex;\n  gap: 0;\n  margin-bottom: 1.5rem;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid #d1d5db;\n  width: fit-content;\n}\n\n.view-toggle button {\n  padding: 0.5rem 1.2rem;\n  border: none;\n  background: white;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #374151;\n  transition: background 0.2s;\n}\n\n.view-toggle button.active {\n  background: #2563eb;\n  color: white;\n}\n\n.map-wrapper {\n  height: 500px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #d1d5db;\n  position: relative;\n}\n\n.map-no-results {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.9);\n  padding: 1rem 1.5rem;\n  border-radius: 6px;\n  z-index: 1000;\n}\n\n@media (max-width: 768px) {\n  .find-job-container {\n    flex-direction: column;\n  }\n\n  .find-job-sidebar {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
